import React from 'react'
import { Button, Row, Col } from 'antd'
import {NumCompare, SelectGroup, DateCompare, TextInput, CascaderOption, TreeSelectGroup} from './corAdvanceFormItem'
import './youkee.less'

//高级搜索的表单
class AdvanceForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileds: props.fileds,
      handle: props.handle,
      reset: props.reset,
      fieldHandle: props.fieldHandle,
      childRefs: []
    };
    this.gtChange = this.gtChange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }
  gtChange(value) {
    var val = this.state.val;
    val.eq = '';
    val.gt = value;

    this.setState({val: val});
    this.state.handle(this.state.name, val);
  }
  resetForm() {
    var thisRefs = this.refs;
    for (var key in thisRefs) {
      if (key !== 'advform')
        thisRefs[key].reset();
    }

    thisRefs['advform'].reset();
    this.state.reset();
  }
  submitForm(e) {
    e.preventDefault();
    e.stopPropagation();
    this.state.handle(this.refs.advform);
  }
  render() {
    var self = this;
    var fileds = self.state.fileds.map((item, j)=>{
      return Object.assign({}, item, self.props.fileds[j]);
    });
    var fieldHandle = this.state.fieldHandle;

    return (
      <form className="adv-form" ref='advform' onSubmit={this.submitForm} style={{maxHeight:'450px', overflow: 'visible'}}>
        {fileds.map(function (item, key) {
          var item_props = {...item, handle: fieldHandle};

          if (item.type === 'numComp') {
            return <NumCompare ref={'numComp'+key} {...item_props} key={key}/>
          } else if (item.type === 'select') {
            return <SelectGroup ref={'selectGroup'+key} {...item_props} key={key}/>
          } else if (item.type === 'dateComp') {
            return <DateCompare ref={'dateCompare'+key} {...item_props} key={key}/>
          } else if (item.type === 'cascader') {
            return <CascaderOption ref={'cascaderOption'+key} {...item_props} key={key}/>
          } else if (item.type === 'treeSelect') {
            return <TreeSelectGroup ref={'treeSelectGroup'+key} {...item_props} key={key}/>
          } else {
            return <TextInput ref={'textInput'+key} {...item_props} key={key}/>
          }
        })}
        <Row style={{marginTop: '15px'}}>
          <Col span={24} style={{textAlign: 'right'}}>
            <Button style={{marginRight: 8}} onClick={this.resetForm}>
              重置
            </Button>
            <Button type="primary" htmlType="submit">确定</Button>
          </Col>
        </Row>
      </form>
    );
  }
}

export default AdvanceForm



// WEBPACK FOOTER //
// ./src/components/advanceForm.js